const STORAGE_KEY = 'datastrat-theme';

export default function darkMode() {
    const toggle = document.getElementById('ds-dark-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', () => {
        const current = document.documentElement.getAttribute('data-theme');
        const next = current === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        localStorage.setItem(STORAGE_KEY, next);
    });
}
